import React, { useState } from "react";
import { ReactTitle } from "react-meta-tags";
import { useTranslation } from "react-i18next";

import ClientCountries from "../../shared/countries/ClientCountries";
import Client from "../../../../static/images/find-institution.svg";
import MainTemplate from "../mainTemplate";
import Search from "../../shared/custom-components/search";
import { cleanIputTextNumber } from "../../utils/functions";

const Main = () => {
  const [{ searchValue, country, errors }, setState] = useState({
    searchValue: "",
    country: "",
    errors: [],
  });

  const onKeyPress = ({ key }) => {
    key === "Enter" && searchAction();
  };

  const handlerChange = ({ target: { value } }) => {
    setState((prev) => ({
      ...prev,
      searchValue: cleanIputTextNumber("text", value),
    }));
  };

  const searchAction = () => {
    if (searchValue != "" && country !== "") {
      window.location = `/bscadministrator/add/${searchValue}/${country}`;
    } else {
      if (country === "") errors["country"] = "Debe seleccionar un país";
      setState((prev) => ({ ...prev, errors }));
    }
    return false;
  };

  const setCountry = (e) => {
    setState((prev) => ({ ...prev, country: e.target.value, errors: [] }));
  };

  const { message } = useTranslation().t("clients.users", {
    returnObjects: true,
  });

  return (
    <MainTemplate>
      <ReactTitle title={`Registro de clientes - Reverse Factoring`} />
      <div className="main-backoffice">
        <img src={Client} className="clientImage" />
        <p className="welcome">{message.title}:</p>
        <p className="client">
          {message.subtitle}
          <br />
          {message.second_subtitle}
        </p>
        <div className="line-client-add"></div>
        <div className="inline-form">
          <ClientCountries
            id={`client-country`}
            className="client-country"
            onChange={(e) => setCountry(e)}
            error={errors["country"]}
          />
          <Search
            id="search-field"
            name="searchValue"
            placeholder={message.placeholder}
            className="Input__input Search__input"
            onChange={handlerChange}
            onSearchClick={searchAction}
            onKeyPress={onKeyPress}
            value={searchValue}
          />
        </div>
      </div>
    </MainTemplate>
  );
};

export default Main;
